import React, {memo} from 'react';
import cl from 'classnames';
import * as PropTypes from 'prop-types';
import Modal from '../../index';
import {t} from '../../../../services/i18nHandler';

function ModalConfirm({
  text, title, onClose, isOpen, onConfirm, textCenter, confirmBtnText, cancelBtnText, loading, className,
}) {
  return (
    <Modal className="modal-center" isOpen={isOpen} onHide={onClose}>
      <div className="modal-inner">
        <div className={`modal-container modal-confirm ${className}`}>
          {title && (
            <div className="modal-header">
              <div
                className="modal-header_title"
                style={{textAlign: textCenter ? 'center' : 'left'}}
                dangerouslySetInnerHTML={{__html: title}}
              />
            </div>
          )}
          <div className="modal-content">
            <div
              className={cl('modal-text', {
                'as-title-text': !title,
              })}
              style={{textAlign: textCenter ? 'center' : 'left'}}
              dangerouslySetInnerHTML={{__html: text}}
            />
            <div className="btn-wrap">
              <button
                type="button"
                className="btn btn-base"
                onClick={loading ? null : onConfirm}
              >
                {t(confirmBtnText)}
                {loading && (<span className="loading-circle" />)}
              </button>
              <button type="button" className="btn btn-default btn-conture" onClick={onClose}>
                {t(cancelBtnText)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ModalConfirm.defaultProps = {
  confirmBtnText: 'buttons.submit',
  cancelBtnText: 'buttons.cancel',
  className: '',
  loading: false,
  textCenter: false,
};

ModalConfirm.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  textCenter: PropTypes.bool,
};

export default memo(ModalConfirm);
